import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintenanceManEditChargeTimeConf(data) {
    return maintainRequest.post("/device/maintenanceMan/chargingTimeConf/editChargeTimeConf",
        data)
}
